var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{class:_vm.styleMain},[_c('team-header',{attrs:{"match":_vm.match,"team":_vm.team}}),_c('div',{staticClass:"content"},[_c('team-buttons',{attrs:{"match":_vm.match,"team":_vm.team}}),_c('team-statistics',{attrs:{"match":_vm.match,"team":_vm.team}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }